import { useQuery } from '@tanstack/react-query';
import { BillingService } from '../BillingService';

// Purchase Order queries
export const useBillingList = ({
  page,
  pageSize,
  search,
  status,
  sortBy,
  sortOrder,
}) =>
  useQuery({
    queryKey: [
      'billing',
      'list',
      page,
      pageSize,
      search,
      status,
      sortBy,
      sortOrder,
    ],
    queryFn: () =>
      BillingService.getBillingList({
        page,
        pageSize,
        search,
        status,
        sortBy,
        sortOrder,
      }),
    placeholderData: (prev) => prev,
  });

export const useBillingInfo = (id) =>
  useQuery({
    queryKey: ['billing', 'info', id],
    queryFn: () => BillingService.getBillingInfo(id),
    enabled: !!id,
  });

// Milestone queries
export const useMilestoneList = ({ page, pageSize }) =>
  useQuery({
    queryKey: ['milestones', 'list', page, pageSize],
    queryFn: () => BillingService.getMilestoneList({ page, pageSize }),
  });

// Invoice queries
export const useInvoiceList = ({
  page,
  pageSize,
  search,
  status,
  sortBy,
  sortOrder,
}) =>
  useQuery({
    queryKey: [
      'invoices',
      'list',
      page,
      pageSize,
      search,
      status,
      sortBy,
      sortOrder,
    ],
    queryFn: () =>
      BillingService.getInvoiceList({
        page,
        pageSize,
        search,
        status,
        sortBy,
        sortOrder,
      }),
    placeholderData: (prev) => prev,
  });

export const useInvoiceInfo = (id) =>
  useQuery({
    queryKey: ['invoices', 'info', id],
    queryFn: () => BillingService.getInvoiceInfo(id),
    enabled: !!id,
  });

// Proforma Invoice queries
export const useProformaInvoiceList = ({
  page,
  pageSize,
  search,
  status,
  sortBy,
  sortOrder,
}) =>
  useQuery({
    queryKey: [
      'proforma-invoices',
      'list',
      page,
      pageSize,
      search,
      status,
      sortBy,
      sortOrder,
    ],
    queryFn: () =>
      BillingService.getProformaInvoiceList({
        page,
        pageSize,
        search,
        status,
        sortBy,
        sortOrder,
      }),
    placeholderData: (prev) => prev,
  });

export const useProformaInvoiceInfo = (id) =>
  useQuery({
    queryKey: ['proforma-invoices', 'info', id],
    queryFn: () => BillingService.getProformaInvoiceInfo(id),
    enabled: !!id,
  });

export const useCreditNoteInfo = (id) =>
  useQuery({
    queryKey: ['credit-notes', 'info', id],
    queryFn: () => BillingService.getCreditNoteInfo(id),
    enabled: !!id,
  });

export const useCreditNoteList = ({ page, pageSize, status }) =>
  useQuery({
    queryKey: ['credit-notes', 'list', page, pageSize, status],
    queryFn: () =>
      BillingService.getCreditNoteList({
        page,
        pageSize,
        status,
      }),
    keepPreviousData: true,
  });

// type: 'work_order' | 'invoice' | 'proforma_invoice' — one per call, see
// BillingService.getBillingSummary.
export const useBillingSummary = (type) =>
  useQuery({
    queryKey: ['billing', 'summary', type],
    queryFn: () => BillingService.getBillingSummary(type),
    enabled: !!type,
  });
